module.exports = __webpack_public_path__ + "static/Alexandre-Moreira-c89ca2baef11bc8b35b2144df1769ec9.jpg";